<template>
  <view v-if="visible" class="page-loading-mask">
    <view class="wrapper">
      <view class="spinner">
        <!-- 中间倒计时 -->
        <view class="countdown">{{ time }}</view>

        <view class="spinner-container container1">
          <view class="circle1"></view>
          <view class="circle2"></view>
          <view class="circle3"></view>
          <view class="circle4"></view>
        </view>
        <view class="spinner-container container2">
          <view class="circle1"></view>
          <view class="circle2"></view>
          <view class="circle3"></view>
          <view class="circle4"></view>
        </view>
        <view class="spinner-container container3">
          <view class="circle1"></view>
          <view class="circle2"></view>
          <view class="circle3"></view>
          <view class="circle4"></view>
        </view>
      </view>
    </view>
  </view>
</template>

<script setup lang="ts">
import { onBeforeUnmount, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import mitt from 'mitt-utils';
import {  getPid } from 'exeAction-utils';

console.log('m_loading module loaded');

const props = defineProps({
  config: {
    type: Object,
    default: () => ({}),
  },
});

const route = useRoute();
const cfg: any = props.config as any;
const pid = cfg?.pid ?? getPid(route);
const { did } = cfg;

console.log('m_loading setup ->', { pid, did, hasConfig: !!cfg, cfg });

const visible = ref(false);
const initialTime = ref(10); // 初始值
const time = ref(10);
let timer: any = null;

function startCountdown() {
  if (timer) return;
  timer = setInterval(() => {
    time.value = time.value > 0 ? time.value - 1 : initialTime.value;
  }, 1000);
}

function stopCountdown() {
  if (!timer) return;
  clearInterval(timer);
  timer = null;
}

const mittName = did === undefined || did === null ? null : `${pid}_mitt_did_${did}`;
console.log('m_loading mittName ->', mittName);

const mittHandler = (par: any) => {
  const flg = par?.flg;
  if (flg === 'open' || flg === 'f_open') {
    visible.value = true;
    console.log('加载展示111111111111111')
  } else if (flg === 'f_close') {
    visible.value = false;
  }
};

if (mittName) {
  mitt.on(mittName, mittHandler);
  console.log('m_loading listen ->', mittName);
}

watch(
  visible,
  (val) => {
    if (val) {
      time.value = initialTime.value;
      startCountdown();
    } else {
      stopCountdown();
    }
  },
  { immediate: true }
);

onBeforeUnmount(() => {
  stopCountdown();
  if (mittName) {
    try {
      mitt.off(mittName, mittHandler);
    } catch (e) {
      try {
        mitt.off(mittName);
      } catch (e2) {
        // ignore
      }
    }
  }
});
</script>

<style>
.page-loading-mask {
  position: fixed;
  inset: 0;
  z-index: 10000;
  background: rgba(0, 0, 0, 0.35);
}

.page-loading-mask view {
  display: block;
}

.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.spinner {
  margin: 0;
  width: 80px;
  height: 80px;
  position: relative;
}

/* 中间倒计时 */
.countdown {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 28px;
  font-weight: bold;
  color: #fff;
  z-index: 10;
}
.container1 > view,
.container2 > view,
.container3 > view {
  width: 10px;
  height: 10px;
  background-color: #fff;
  border-radius: 100%;
  position: absolute;
  -webkit-animation: bouncedelay 1.2s infinite ease-in-out;
  animation: bouncedelay 1.2s infinite ease-in-out;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.spinner .spinner-container {
  position: absolute;
  width: 100%;
  height: 100%;
}
.container2 {
  -webkit-transform: rotateZ(45deg);
  transform: rotateZ(45deg);
}
.container3 {
  -webkit-transform: rotateZ(90deg);
  transform: rotateZ(90deg);
}
.circle1 {
  top: 0;
  left: 0;
}
.circle2 {
  top: 0;
  right: 0;
}
.circle3 {
  right: 0;
  bottom: 0;
}
.circle4 {
  left: 0;
  bottom: 0;
}
.container2 .circle1 {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}
.container3 .circle1 {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}
.container1 .circle2 {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}
.container2 .circle2 {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}
.container3 .circle2 {
  -webkit-animation-delay: -0.7s;
  animation-delay: -0.7s;
}
.container1 .circle3 {
  -webkit-animation-delay: -0.6s;
  animation-delay: -0.6s;
}
.container2 .circle3 {
  -webkit-animation-delay: -0.5s;
  animation-delay: -0.5s;
}
.container3 .circle3 {
  -webkit-animation-delay: -0.4s;
  animation-delay: -0.4s;
}
.container1 .circle4 {
  -webkit-animation-delay: -0.3s;
  animation-delay: -0.3s;
}
.container2 .circle4 {
  -webkit-animation-delay: -0.2s;
  animation-delay: -0.2s;
}
.container3 .circle4 {
  -webkit-animation-delay: -0.1s;
  animation-delay: -0.1s;
}
@-webkit-keyframes bouncedelay {
  0%,
  80%,
  100% {
    -webkit-transform: scale(0);
  }
  40% {
    -webkit-transform: scale(1);
  }
}
@keyframes bouncedelay {
  0%,
  80%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  40% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}
</style>